import { gql } from "@apollo/client";

export default gql`
  mutation createRandomMessage($data: createRandomMessageInput){
    createRandomMessage(data: $data){
        success
        data
        code
        message
    }
}
`
